import { localizeMarketingText, type MarketingAmountTokens } from './marketingCurrency.js';
import { substituteMarketingBrandingInText } from './marketingSiteContact.js';

/** Default tokens for edge crawler homepage copy ({fromPrice2999}). */
const DEFAULT_HOMEPAGE_EDGE_MARKETING_TOKENS: MarketingAmountTokens = {
  extra: { '2999': 2999 },
};

/** Legacy T&B homepage SEO corpus — substituted at runtime for tenants. */
export const HOMEPAGE_SEO_TITLE =
  'Cleaning Service Kochi | Tools & Bubbles | Professional Deep Cleaning | 4.8★';

export const HOMEPAGE_SEO_DESCRIPTION =
  "Kochi's #1 cleaning service since 2009 — 4.8★ Google, 230+ reviews, 10,000+ customers. Deep cleaning {fromPrice2999}. Same-day service. Homes, offices & commercial. Book online or call for instant quote!";

/** Default INR formatter for edge crawlers (matches patch-static-marketing.js). */
export const defaultHomepageFormatMoney = (amount: number) => {
  try {
    return `₹${amount.toLocaleString('en-IN')}`;
  } catch {
    return `₹${String(amount)}`;
  }
};

export function buildHomepageSeoCopy(
  formatMoney: (amount: number) => string,
  branding: { phone?: string; email?: string; companyName?: string },
  tokens: MarketingAmountTokens = DEFAULT_HOMEPAGE_EDGE_MARKETING_TOKENS,
  overrides?: { title?: string; description?: string },
): { title: string; description: string } {
  const localize = (text: string) =>
    substituteMarketingBrandingInText(localizeMarketingText(text, formatMoney, tokens), branding);
  return {
    title: localize(overrides?.title?.trim() || HOMEPAGE_SEO_TITLE),
    description: localize(overrides?.description?.trim() || HOMEPAGE_SEO_DESCRIPTION),
  };
}
